import React from 'react';

import type { Get_Ad_Permitted_TimezonesQuery } from '../../../../../../apis/graphql';
import type { DropdownOption } from '../../../../../../common/Dropdown';
import Dropdown from '../../../../../../common/Dropdown';
import { useFieldFast } from '../../../../../../common/Form/hooks';
import { DropdownOptions } from '../../../../../../common/hooks/config';
import { useFetchDropdownOptions } from '../../../../../../common/hooks/queries/useFetchDropdownOptions';
import { getTimezoneWithGMT } from '../../../../../../common/SelectTimeZone/utils';
import { useScheduleFormState } from '../../hooks/useScheduleFormState';
import { CpScheduleFormFields } from '../../types';

type Props = {
  isDisabled?: boolean;
};

const TimezoneDropdown = ({ isDisabled = false }: Props): React.JSX.Element => {
  const { resetRangeErrors } = useScheduleFormState();
  const [{ value: timezone }, { error }, { setValue: setTimezone }] = useFieldFast<string>(
    CpScheduleFormFields.Timezone
  );
  const { options } = useFetchDropdownOptions<Get_Ad_Permitted_TimezonesQuery>(DropdownOptions.AdPermittedTimezones);

  const selectedTimezone = options.find((option) => option.label === getTimezoneWithGMT(timezone)) ?? {
    value: timezone,
    label: getTimezoneWithGMT(timezone),
  };

  const onTimeZoneChange = (selectedTimeZone: DropdownOption | null): void => {
    setTimezone(selectedTimeZone?.value ?? '');
    resetRangeErrors();
  };

  return (
    <Dropdown
      classNameModifier="select-timezone"
      options={options}
      isSearchable={false}
      isDisabled={isDisabled}
      value={selectedTimezone}
      onChange={onTimeZoneChange}
      dataTestId="timezone-dropdown"
      optionCompareKey={'label'}
      errMsg={error}
    />
  );
};

export default TimezoneDropdown;
